import React from 'react';
import PropTypes from 'prop-types';

const Star = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
  >
    <path
      d="M7.99956 11.5125L10.7662 13.1859C11.2729 13.4925 11.8929 13.0392 11.7596 12.4659L11.0262 9.31919L13.4729 7.19919C13.9196 6.81253 13.6796 6.07919 13.0929 6.03253L9.87289 5.75919L8.61289 2.78586C8.38623 2.24586 7.61289 2.24586 7.38623 2.78586L6.12623 5.75253L2.90623 6.02586C2.31956 6.07253 2.07956 6.80586 2.52623 7.19253L4.97289 9.31253L4.23956 12.4592C4.10623 13.0325 4.72623 13.4859 5.23289 13.1792L7.99956 11.5125Z"
      fill="#FFB302"
    />
  </svg>
);

Star.propTypes = {
  size: PropTypes.number,
};

export default Star;
